import Form from "../Form/Form.js";
import { useToasts } from "react-toast-notifications";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import CallToActionSubscribe from "./CallToActionSubscribe.tsx";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import Image from "components/Elements/Image/Image.tsx";

import "./SaveMail.scss";
import { useState } from "react";

const SaveMail = ({ isMailSender, saveMailByCode, ...rest }) => {
  const { addToast } = useToasts();
  const { getTextByKey, getLanguageCulture } = useContent();
  const { mobileCondition } = useMediaQueries();

  const subscribeOnly = rest.subscribeOnly;

  const [openHaveJumbocodeModal, setOpenHaveJumbocodeModal] = useState(false);

  const field = {
    SaveCode: {
      fieldKey: "SaveCode",
      element: "input",
      title: "SaveCode",
      placeholder: "save-code-placeholder",
      tooltip: {
        text: "save-code-tooltip",
      },
    },
  };

  const handleOpenHaveJumbocodeModal = () => {
    setOpenHaveJumbocodeModal(true);
  };

  const handleSubmit = async (body) => {
    if (body.SaveCode) {
      const response = await saveMailByCode(
        body.SaveCode,
        getLanguageCulture()
      );
      if (response.status === "success") {
        addToast(getTextByKey("save-mail-with-code-success"), {
          appearance: "success",
        });
        rest.closeElement();
        return {
          status: "success",
          message: "",
        };
      } else
        return {
          status: response.status,
          message: "invalid-jumbocode",
        };
    } else {
      return {
        status: "error",
        message: "empty-jumbocode",
      };
    }
  };

  return (
    <div
      className={`save-mail-container ${
        !isMailSender || mobileCondition ? "single-section" : ""
      }`}
    >
      {!openHaveJumbocodeModal && (
        <CallToActionSubscribe
          isOpen={handleOpenHaveJumbocodeModal}
          subscribeOnly={subscribeOnly}
        />
      )}

      {!subscribeOnly && openHaveJumbocodeModal ? (
        <div className="save-mail right-section">
          <Image
            name="cloud-with-folders"
            ext="png"
            className="save-with-jmcode-image"
          />
          <div className="save-mail-title-wrap">
            <div className="save-mail-title">
              {getTextByKey("save-mail-modal-6-months-title")}
            </div>
            <div className="save-mail-sub-title">
              {getTextByKey("save-mail-modal-6-months-subtitle")}
            </div>
          </div>
          <div className="tooltip-form-container">
            <Form
              fields={field}
              fieldsProps={{ field: "square", label: "hidden" }}
              onSubmit={handleSubmit}
              withoutRecaptcha={true}
              submitProps={{
                title: getTextByKey("confirm-jumbocode"),
              }}
            ></Form>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SaveMail;
